const csvToHtml = (input, { hasHeader = true, separator = "," }) => {
  let output = "<table>"

  const rows = input.split(/\r?\n|\r/).filter((row) => row !== "")
  for (let i = 0; i < rows.length; i += 1) {
    if (hasHeader && i === 0) {
      output += "<thead>"
      output += "<tr>"
    } else {
      output += "<tr>"
    }

    const columns = rows[i].split(separator)
    for (let j = 0; j < columns.length; j += 1) {
      if (hasHeader && i === 0) {
        output += "<th>"
        output += columns[j]
        output += "</th>"
      } else {
        output += "<td>"
        output += columns[j]
        output += "</td>"
      }
    }

    if (hasHeader && i === 0) {
      output += "</tr>"
      output += "</thead>"
      output += "<tbody>"
    } else {
      output += "</tr>"
    }
  }

  output += "</tbody>"
  output += "</table>"

  return output
}

module.exports = csvToHtml
